export default __webpack_public_path__ + "static/Tek_Forcefield-37e3a7b287874569fcadda1288d9746a.png";